import React, { Component } from 'react';
import injectSheet from 'react-jss';
import { Subscribe } from 'unstated';
import {
  Card, CardText, CardBody, CardTitle, CardImg, TabContent, TabPane, Nav, NavItem, NavLink,
} from 'reactstrap';
import _ from 'lodash';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import faker from 'faker';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import ListingContainer from '../containers/ListingContainer';
import FilterBtn from '../components/FilterBtn';

const styles = {
  BodyWrapper: {
    // width: 'calc(100% - 85px)',
    // margin: '0 auto',
    // display: 'flex',
    // flexWrap: 'wrap',
    '& a': {
      textDecoration: 'none',
    },
  },
  cardContainer: {
    // marginRight: '2rem',
    // marginBottom: '2rem',
    // boxShadow: '0 0.125rem 0.75rem -0.125rem rgba(0, 0, 0, 0.25)',
    // borderRadius: '6px',
    // minWidth: '16.25rem',
    // maxWidth: '16.25rem',
    // minHeight: '25rem',
    // maxHeight: '25rem',
    // cursor: 'pointer',
    // '&:hover': {
    //   textDecoration: 'none',
    //   boxShadow: 'rgb(187, 187, 187) -2px 0px 8px',
    // },
  },
  card: {
    marginRight: '2rem',
    marginBottom: '2rem',
    boxShadow: '0 0.125rem 0.75rem -0.125rem rgba(0, 0, 0, 0.25)',
    borderRadius: '6px',
    minWidth: '16.25rem',
    maxWidth: '16.25rem',
    minHeight: '25rem',
    maxHeight: '25rem',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'none',
      boxShadow: 'rgb(187, 187, 187) -2px 0px 8px',
    },
  },
  title: {
    marginBottom: '0.2rem',
    fontSize: '0.9rem',
    fontFamily: 'Lato, Arial',
    color: '#1F1F1F',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  titleName: {
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    color: '#656565',
    lineHeight: '1.3125rem',
    // TODO: this only works on Chrome
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    // END TODO
  },
  description: {
    fontFamily: 'Lato',
    fontSize: '0.875rem',
    color: '#656565',
    lineHeight: '1.3125rem',
    // TODO: this only works on Chrome
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    // END TODO
  },
  cardImageWrapper: {
    height: '10rem',
  },
  cardBody: {
    // marginTop: '1rem',
  },
  image: {
    width: '100%',
    height: '100%',
  },
  listingHeader: {
    width: 'calc(100% - 85px)',
    margin: '2rem 4rem auto',
    marginBottom: '1rem',
  },
  leftSideBtnWrapper: {
    display: 'flex',
    // 'float': 'left',
    '& > .nav.nav-tabs': {
      border: 'none',
    },
  },
  activeBtn: {
    border: '1px solid #34A5DA',
    background: '#34A5DA',
    fontFamily: 'Lato, Arial',
    fontSize: '16px',
    color: '#FFFFFF !important',
    padding: '3px 20px',
    borderRadius: '1.5rem',
    cursor: 'pointer',
    '&.nav-link': {
      borderTopRightRadius: '1.5rem',
      borderTopLeftRadius: '1.5rem',
    },
  },
  normalBtn: {
    fontFamily: 'Lato, Arial',
    fontSize: '1rem',
    color: '#979797',
    textAlign: 'center',
    cursor: 'pointer',
    width: '5.625rem',
    lineHeight: '1.875rem !important',
    border: 'none !important',
    '&.active': {
      borderBottom: '1px solid #34A5DA !important',
      color: '#34A5DA !important',
    },
  },
  cardFooter: {
    fontFamily: 'Lato, Arial',
    fontSize: '0.75rem',
    fontWeight: 'bold',
    color: '#1F1F1F',
    padding: '2px 15px',
    background: '#F2F3F1',
    lineHeight: '21px',
    borderRadius: '1.5rem',
    width: 'fit-content',
    marginLeft: '1rem',
    marginBottom: '1rem',
  },
  tabPane: {
    width: 'calc(100% - 150px)',
    margin: '0 auto',
    display: 'none',
    flexWrap: 'wrap',
    '&.active': {
      display: 'flex',
    },
  },
};

const GET_DRAFT_MANY = () => gql`
  query {
    draftMany {
      _id
      title,
      blurb,
      image,
      __typename,
      template {
        _id,
        name,
        slug
      }
    }
  }
`;

function renderDraftMany(props) {
  const { classes } = props;
  return (
    <Query query={GET_DRAFT_MANY()}>
      {({ loading, error, data }) => {
        if (loading) return <div>Loading...</div>;
        if (error) return <div>Error :(</div>;

        return (
          // _.filter(_.sortBy(data.draftMany, ['createdAt']), {template: {name: 'Issue'}}).reverse().map((draft) => {
          _.sortBy(data.draftMany, ['createdAt']).reverse().map((draft) => {
            return (
              <Link key={draft._id} to={`/card/detail/jam/${draft._id}`}>
                <Card className={classes.card}>
                  <div className={classes.cardImageWrapper}>
                    <CardImg top className={classes.image} src={draft.image || faker.image.avatar() /*faker.image.image()*/} alt="Card image cap" />
                  </div>
                  <CardBody className={classes.cardBody}>
                    <CardTitle className={classes.title}>
                      {`${draft.template.name} Jam Title:`}
                    </CardTitle>
                    <CardText className={classes.titleName}>
                      { draft.title }
                    </CardText>
                    <CardTitle className={classes.title}>
                      {`${draft.template.name} Jam Blurb:`}
                    </CardTitle>
                    <CardText className={classes.description}>
                      { draft.blurb }
                    </CardText>
                  </CardBody>
                  <div className={classes.cardFooter}>
                    {`${draft.template.name} Jam`}
                  </div>
                </Card>
              </Link>
            );
          })
        );
      }}
    </Query>
  );
}

const GET_STORY_MANY = () => gql`
  query {
    storyMany {
      _id,
      title,
      blurb,
      image,
      template {
        _id,
        name,
        slug,
      },
      participants {
        displayName
      }
    }
  }
`;

function renderStoryMany(props) {
  const { classes } = props;
  return (
    <Query query={GET_STORY_MANY()}>
      {({ loading, error, data }) => {
        if (loading) return <div>Loading...</div>;
        if (error) return <div>Error :(</div>;

        return (
          _.sortBy(data.storyMany, ['createdAt']).reverse().map((story) => {
            return (
              <Link key={story._id} to={`/card/detail/fruit/${story._id}`}>
                <Card className={classes.card}>
                  <div className={classes.cardImageWrapper}>
                    <CardImg top className={classes.image} src={story.image || faker.image.avatar()} alt="Card image cap" />
                  </div>
                  <CardBody className={classes.cardBody}>
                    <CardTitle className={classes.title}>
                      {`${story.template.name} Title:`}
                    </CardTitle>
                    <CardText className={classes.titleName}>
                      { story.title }
                    </CardText>
                    <CardTitle className={classes.title}>
                      {`${story.template.name} Blurb:`}
                    </CardTitle>
                    <CardText className={classes.description}>
                      { story.blurb }
                    </CardText>
                  </CardBody>
                  <div className={classes.cardFooter}>
                    {story.template.name}
                  </div>
                </Card>
              </Link>
            );
          })
        );
      }}
    </Query>
  );
}

function JamFruitCard(props) {
  const { classes, listing, activeTab } = props;
  // return listing.map(pro => (
    // <Link key={pro._id} to={`/card/detail/${pro._id}`}>
    return (( <div  className={classes.cardContainer} onClick={listing.handleOnClickCard}>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1" className={classes.tabPane}>
            {renderDraftMany(props)}
          </TabPane>
          <TabPane tabId="2" className={classes.tabPane}>
            {/* <Card className={classes.card}>
              <div className={classes.cardImageWrapper}>
                <CardImg top className={classes.image} src={pro.image || faker.image.avatar()} alt="Card image cap" />
              </div>
              <CardBody className={classes.cardBody}>
                <CardTitle className={classes.title}>
                  {`${pro.template.name} Title:`}
                </CardTitle>
                <CardText className={classes.titleName}>
                  { pro.title }
                </CardText>
                <CardTitle className={classes.title}>
                  {`${pro.template.name} Blurb:`}
                </CardTitle>
                <CardText className={classes.description}>
                  { pro.blurb }
                </CardText>
              </CardBody>
              <div className={classes.cardFooter}>
                {pro.template.name}
              </div>
            </Card> */}
            {renderStoryMany(props)}
          </TabPane>
        </TabContent>
      </div>
    // </Link>
  ));
}

function ListingPageHeader(props) {
  const { classes, activeTab, handleToggle } = props;
  return (
    <div className={classes.listingHeader}>
      <div><FilterBtn /></div>
      <div className={classes.leftSideBtnWrapper}>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames(classes.normalBtn, { [classes.activeBtn]: activeTab === '1' })}
              onClick={() => { handleToggle('1'); }}
            >
              Jams
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames(classes.normalBtn, { [classes.activeBtn]: activeTab === '2' })}
              onClick={() => { handleToggle('2'); }}
            >
              Fruit
            </NavLink>
          </NavItem>
        </Nav>
      </div>
    </div>
  );
}

class ListingPage extends Component {
  componentDidMount() {
    if (this.props.listing) {
      this.props.listing.setup();
    }
  }

  componentWillUnmount() {
    this.props.listing.destroy();
  }

  render() {
    const { classes, listing } = this.props;

    if (!(listing && listing.state.draft)) {
      return null;
    }

    return (
      <div>
        <ListingPageHeader activeTab={listing.state.activeTab} handleToggle={listing.toggle} classes={classes} />
        <div className={classes.BodyWrapper}>
          <JamFruitCard activeTab={listing.state.activeTab} listing={listing.state.cardsInfo} classes={classes} />
        </div>
      </div>
    );
  }
}

function ListingPageWrapper(props) {
  const { classes } = props;

  return (
    <Subscribe to={[ListingContainer]}>
      { listing => (
        <div>
          {listing && (
          <ListingPage classes={classes} listing={listing} />
          )}
        </div>
      )}
    </Subscribe>
  );
}

export default injectSheet(styles)(ListingPageWrapper);



// WEBPACK FOOTER //
// ./src/pages/ListingPage.js